"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareErc721ContractsInitialValues = exports.erc721EditContractFilter = exports.erc721CreateContractFilter = exports.erc721ContractsEmptyValuesCreator = void 0;
const draft_js_utils_1 = require("@dzambalaorg/draft-js-utils");
const types_1 = require("../../../../types");
const baseEmptyValues = {
    title: "",
    description: draft_js_utils_1.emptyStateString,
    parameters: {
        vrfSubId: "",
    },
    symbol: "",
    address: "",
    imageUrl: "",
    contractFeatures: [],
};
const erc721ContractsEmptyValuesCreator = profile => ({
    [types_1.ServiceType.ADMIN]: {
        ...baseEmptyValues,
        parameters: {
            vrfSubId: "",
        },
        contractFeatures: [],
    },
    [types_1.ServiceType.OFFICE]: {
        ...baseEmptyValues,
        merchantId: profile.merchantId,
    },
});
exports.erc721ContractsEmptyValuesCreator = erc721ContractsEmptyValuesCreator;
const erc721CreateContractFilter = (service) => ({ title, description, address, imageUrl, symbol, merchantId }) => ({
    title,
    description,
    symbol,
    address,
    imageUrl,
    merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
});
exports.erc721CreateContractFilter = erc721CreateContractFilter;
const erc721EditContractFilter = (service) => ({ title, description, contractStatus, imageUrl, merchantId }) => ({
    title,
    description,
    imageUrl,
    contractStatus,
    merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
});
exports.erc721EditContractFilter = erc721EditContractFilter;
const prepareErc721ContractsInitialValues = (service) => ({ id, title, description, imageUrl, contractStatus, address, symbol, contractFeatures, parameters, merchantId, }) => {
    return {
        id,
        title,
        address,
        symbol,
        description,
        contractStatus,
        imageUrl,
        contractFeatures,
        parameters,
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareErc721ContractsInitialValues = prepareErc721ContractsInitialValues;
//# sourceMappingURL=schemas.js.map